import * as React from "react";

import "./agreement-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

export const AgreementModal = ({agreementGroupName=undefined, agree=undefined, next: rootNext}) => cs(
    consumeContext("apis"),
    ["customerAgreement", ({apis}, next) => Load2({
        fetch: () => apis.next.getCustomerAgreement(agreementGroupName),
        next,
    })],
    ["modal", ({customerAgreement}, next) => ModalService3({
        title: "User Agreement",
        width: 700,
        next,
        rootNext: (_) => rootNext({
            ..._,
            available: !!customerAgreement.value?.length,
        }),
    })],
    ({modal, customerAgreement}) => (
        <div className="agreement-modal-722">
            {/*<div className="header">*/}
            {/*    <div className="title">*/}
            {/*        User Agreement*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className="content">

                {customerAgreement.loading && (
                    <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                        Loading...
                    </div>
                )}

                {customerAgreement?.value?.map((agreement, i) => (
                    <div className="agreement" key={i}>
                        <p
                            className="text"
                            dangerouslySetInnerHTML={{
                                __html: agreement.description,
                            }}
                        >
                        </p>
                    </div>
                ))}

            </div>

            <div className="footer">
                <button {...{
                    className: "next",
                    "xd-qa-type": "button",
                    "xd-qa-name": "Agree",
                    onClick: () => {
                        agree?.();
                        modal.params.onYes?.();
                        modal.close();
                    },
                }}>
                    Agree
                </button>
            </div>
        </div>
    ),
);
